import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { API_BASE_URL } from "../config";

function BiochemistryForm() {
  const initialForm = {
    name: "",
    ageSex: "",
    doctor: "",
    date: "",
    postMealSugar: "",
  };

  const [form, setForm] = useState(initialForm);
  const [reports, setReports] = useState([]);
  const [editId, setEditId] = useState(null);
  const [viewData, setViewData] = useState(null);

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = () => {
    axios
      .get(`${API_BASE_URL}/api/biochemistry-reports`)
      .then((res) => setReports(res.data))
      .catch((err) => console.error("Error fetching reports:", err));
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (editId) {
      axios
        .put(`${API_BASE_URL}/api/biochemistry-reports/${editId}`, form)
        .then(() => {
          alert("Biochemistry Report Updated!");
          setForm(initialForm);
          setEditId(null);
          fetchReports();
        })
        .catch(() => alert("Error updating Biochemistry Report!"));
    } else {
      axios
        .post(`${API_BASE_URL}/api/biochemistry-reports`, form)
        .then(() => {
          alert("Biochemistry Report Saved!");
          setForm(initialForm);
          fetchReports();
        })
        .catch(() => alert("Error saving Biochemistry Report!"));
    }
  };

  const handleEdit = (report) => {
    setForm(report);
    setEditId(report.id);
    setViewData(null);
    window.scrollTo(0, 0);
  };

  const handleView = (report) => {
    setViewData(report);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this report?")) {
      axios
        .delete(`${API_BASE_URL}/api/biochemistry-reports/${id}`)
        .then(() => {
          alert("Biochemistry Report Deleted!");
          fetchReports();
        })
        .catch(() => alert("Error deleting Biochemistry Report!"));
    }
  };

  return (
    <div className="container my-3">
      <h3>Biochemistry Report Form {editId ? "(Edit)" : "(New)"}</h3>

      <div className="row mb-2">
        <div className="col-md-6">
          <label>Pt. Name:</label>
          <input
            type="text"
            className="form-control"
            name="name"
            value={form.name}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-6">
          <label>Age/Sex:</label>
          <input
            type="text"
            className="form-control"
            name="ageSex"
            value={form.ageSex}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="row mb-2">
        <div className="col-md-6">
          <label>Ref. by Dr.:</label>
          <input
            type="text"
            className="form-control"
            name="doctor"
            value={form.doctor}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-6">
          <label>Date:</label>
          <input
            type="date"
            className="form-control"
            name="date"
            value={form.date}
            onChange={handleChange}
          />
        </div>
      </div>

      <h5>INVESTIGATION</h5>
      <div className="row mb-3">
        <div className="col-md-6">
          <label>Post Meal Blood Sugar (mg/dl):</label>
          <input
            type="number"
            className="form-control"
            name="postMealSugar"
            value={form.postMealSugar}
            onChange={handleChange}
          />
          <small className="text-muted">Normal Range: 80 - 140 mg/dl</small>
        </div>
      </div>

      <button className="btn btn-success mt-3" onClick={handleSubmit}>
        💾 {editId ? "Update Report" : "Save Report"}
      </button>

      <hr />

      <h4>Biochemistry Reports List</h4>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Pt. Name</th>
            <th>Age/Sex</th>
            <th>Date</th>
            <th>Doctor</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {reports.map((report) => (
            <tr key={report.id}>
              <td>{report.name}</td>
              <td>{report.ageSex}</td>
              <td>{report.date}</td>
              <td>{report.doctor}</td>
              <td>
                <button
                  className="btn btn-info btn-sm me-2"
                  onClick={() => handleView(report)}
                >
                  👁️ View
                </button>
                <button
                  className="btn btn-warning btn-sm me-2"
                  onClick={() => handleEdit(report)}
                >
                  ✏️ Edit
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(report.id)}
                >
                  🗑️ Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Print Area */}
      {viewData && (
        <>
          <hr />
          <div
            className="print-area"
            style={{
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
              color: "#000",
              padding: "10mm",
            }}
          >
            {/* Report Title */}
            <div
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "10px",
              }}
            >
              BIOCHEMISTRY REPORT
            </div>

            {/* Patient Info */}
            <table
              style={{
                width: "100%",
                marginBottom: "15px",
                border: "none",
                fontSize: "14px",
              }}
            >
              <tbody>
                <tr>
                  <td style={{ textAlign: "left", width: "50%" }}>
                    <strong>Pt. Name:</strong> {viewData.name}
                  </td>
                  <td style={{ textAlign: "right", width: "50%" }}>
                    <strong>Ref. by Dr.:</strong> {viewData.doctor}
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left" }}>
                    <strong>Age/Sex:</strong> {viewData.ageSex}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    <strong>Date:</strong> {viewData.date}
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Investigation Title */}
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                textDecoration: "underline",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              INVESTIGATION
            </div>

            {/* Investigation Table */}
            <table
              className="table table-bordered"
              style={{ width: "100%", borderCollapse: "collapse" }}
            >
              <thead>
                <tr>
                  <th>Test</th>
                  <th>Result</th>
                  <th>Normal Range</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Post Meal Blood Sugar</td>
                  <td>{viewData.postMealSugar} mg/dl</td>
                  <td>80 - 140 mg/dl</td>
                </tr>
              </tbody>
            </table>

            {/* Footer */}
            <p className="text-center mt-4">
              <strong>*****END OF REPORT*****</strong> &nbsp;&nbsp;&nbsp;&nbsp;
              Technologist
            </p>
          </div>

          {/* Print Button */}
          <button
            className="no-print btn btn-primary my-3"
            onClick={() => window.print()}
          >
            🖨️ Print Report
          </button>
        </>
      )}
    </div>
  );
}

export default BiochemistryForm;
